import { BrowserRouter, Routes, Route } from 'react-router-dom';

import { PATH_PREFIX } from '../constants';
import { Detail } from './Detail';
import { CatalogList } from './CatalogList';
import { Layout } from './Layout';

export const CATALOG_LIST_PATH = '/';

export const Router: React.FC<{}> = () => {
  return (
    <BrowserRouter window={window} basename={PATH_PREFIX}>
      <Layout>
        <Routes>
          <Route path={CATALOG_LIST_PATH} element={<CatalogList />} />
          <Route path='/:uuid' element={<Detail />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
};
